import "./Frame.scss";
import classNames from "classnames";

export function Frame({ active, children, ...props })
{
    return (<div styleName={classNames("frame", { active })} {...props}>
        {children}
    </div>);
}